export const Checkbox = ({
  isSelected,
  onChange,
  label,
  field,
  extraText,
  className,
  isValidDisabled,
}: any) => {
  return (
    <>
      {extraText && <p className='text-muted font-weight-lighter'>{extraText}</p>}
      <div className='form-check form-check-sm form-check-custom form-check-solid'>
        <input
          className={`${className} form-check-input`}
          type='checkbox'
          checked={isSelected}
          onChange={onChange}
          {...field}
          disabled={isValidDisabled ? isValidDisabled : false}
        />
      </div>
    </>
  )
}
